import '../../fonts/fonts.css';
import '../../main.css';

import { useState } from 'react';
import FormWrapper from '../../shared-components/FormWrapper';
import AddressSelect from './steps/AddressSelect';
import Postcode from './steps/Postcode';
import GWCollectionResults from './steps/Results';

function BinLookerUpper() {
  const [ formStep, setFormStep ] = useState(0);
  const nextFormStep = () => setFormStep((currentStep) => currentStep + 1);
  const prevFormStep = () => setFormStep((currentStep) => currentStep - 1);

  const [ loading, setLoading ] = useState(false);
  const [ postcode, setPostcode] = useState("");
  const [ addresses, setAddresses ] = useState([]);
  const [ wasteCollections, setWasteCollections ] = useState([]);
  const [ D365Subs, setD365Subs ] = useState([]);
  const [ D365SubsError, setD365SubsError ] = useState(false);
  const [ collectionRetreived, setCollectionRetreived ] = useState(true);
  const [ routeCode, setRouteCode ] = useState(true);
  


  return (
    <div className='page-container page-container--bins container' >
      <div className='row'>
        <div  class="col-md-8 col-xs-12">
          <h1>Waste and recycling collection dates</h1>
          <br />

          <FormWrapper currentStep={formStep} loading={loading}>
            {formStep == 0 && (
              <Postcode 
                nextFormStep={nextFormStep} 
                setLoading={setLoading} 
                setAddresses={setAddresses}
                postcode={postcode}
                setPostcode={setPostcode} 
              />
            )}
            {formStep == 1 && (
              <AddressSelect 
                nextFormStep={nextFormStep} 
                prevFormStep={prevFormStep} 
                addresses={addresses} 
                postcode={postcode}
                setLoading={setLoading} 
                loading={loading}
                setWasteCollections={setWasteCollections}
                setD365Subs={setD365Subs}
                setRouteCode={setRouteCode}
              />
            )}
            {formStep == 2 && (
              <div>
                <GWCollectionResults 
                  D365Subs={D365Subs}
                  wasteCollections={wasteCollections}
                  D365SubsError={D365SubsError}
                  collectionRetreived={collectionRetreived}
                  routeCode={routeCode}
                  prevFormStep={prevFormStep}
                />
              </div>
            )}
          </FormWrapper>
        </div>
      </div>
    </div>
  );
}

export default BinLookerUpper;
